/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';

const ProductLoading = () => {
  return ( 
    <div className='product-loading'>
      <div className='product-details'>
        <div className="container">
          <div className="product-img skeltoin"></div>
          <div className="product-info">
            <h1 className='skeltoin'></h1>
            <h1 className='skeltoin'></h1>
            <h1 className='skeltoin'></h1>
            <h1 className='skeltoin'></h1>
            <h1 className='skeltoin'></h1>
            <h1 className='skeltoin'></h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductLoading;